export function dataInRequest(params = {}) {
  return {
    type: '@fechamentolmc/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@fechamentolmc/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@fechamentolmc/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@fechamentolmc/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@fechamentolmc/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@fechamentolmc/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@fechamentolmc/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@fechamentolmc/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@fechamentolmc/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@fechamentolmc/RECORD_FILTERING',
    payload: { params },
  };
}
